/* TIENDA DORADA · revelado al hacer scroll (compartido por todas las secciones td-)

   Regla de oro: nada puede quedarse invisible. Si un elemento ya está en pantalla
   o el navegador restauró el scroll y lo dejó por encima, se muestra de inmediato
   sin esperar al observador. Solo se anima lo que aún no se ha visto.
*/
(function(){
  if (window.__tdAnim) return;
  window.__tdAnim = true;

  var SELECTOR = '.td-rv,.td-mask,.td-reveal';
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function marcar(el){ el.classList.add('td-in'); }

  function yaVisto(el){
    var r = el.getBoundingClientRect();
    // por encima del pliegue, ya visible, o ya rebasado por el scroll
    return r.top < window.innerHeight;
  }

  if (!('IntersectionObserver' in window) || reducido){
    window.tdObservar = function(raiz){
      (raiz || document).querySelectorAll(SELECTOR).forEach(marcar);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ window.tdObservar(document); });
    else window.tdObservar(document);
    document.addEventListener('shopify:section:load', function(e){ window.tdObservar(e.target); });
    return;
  }

  var io = new IntersectionObserver(function(entradas){
    entradas.forEach(function(e){
      if (e.isIntersecting){ marcar(e.target); io.unobserve(e.target); }
    });
  }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });

  window.tdObservar = function(raiz){
    (raiz || document).querySelectorAll(SELECTOR).forEach(function(el){
      if (el.classList.contains('td-in')) return;
      if (yaVisto(el)){ marcar(el); return; }
      io.observe(el);
    });
  };

  // red de seguridad: si algo sigue oculto y ya no puede entrar en pantalla, se muestra
  function rescatar(){
    document.querySelectorAll(SELECTOR).forEach(function(el){
      if (!el.classList.contains('td-in') && yaVisto(el)){ marcar(el); io.unobserve(el); }
    });
  }

  function arrancar(){
    window.tdObservar(document);
    // el navegador puede restaurar el scroll después de este punto
    requestAnimationFrame(rescatar);
    setTimeout(rescatar, 300);
    setTimeout(rescatar, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  window.addEventListener('load', rescatar);
  window.addEventListener('pageshow', rescatar);
  document.addEventListener('shopify:section:load', function(e){ window.tdObservar(e.target); });
})();
